import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../HttpClient";

export const getVendorData = createAsyncThunk("vendorData", async () => {
    try {
        const getAllData = await httpClient.get("/internal-db/internal/db/asset_management/add-vendor_data", {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getAllData", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);


export const getHeathStatus = createAsyncThunk("getHeathStatus", async () => {
    // internal-db/internal/db/assetmodels/creator/opa
    // actuator/health/liveness
    try {
        const response = await httpClient.get("/internal-db/internal/db/assetmodels/creator/opa", {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const StatusCode = response.status;
        const result = response.data.Result;
        console.log("success in getHeathStatus", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        console.log("Error:", error);
        throw error;
    }
});

export const sampleCall = createAsyncThunk("sampleCall", async () => {
    try {
        const response = await httpClient.get("/internal-db/internal/db/assetmodels/creator/opa", {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const StatusCode = response.status;
        const result = response.data.Result;
        console.log("success in getHeathStatus", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        console.log("Error:", error);
        throw error;
    }
});


export const getAssetDataByVendorCode = createAsyncThunk("getAssetDataByVendorCode", async (vendor_code) => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/assets_by_vendor?vendor_code=${vendor_code}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);
export const getAssetwithVendorCode = createAsyncThunk("assetwithvendor", async () => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-vendor`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

// export const postTransferReq = createAsyncThunk("postTransferReq", async (data) => {
//     try {
//         const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-transfer-logs`, data, {
//             headers: {
//                 "Content-Type": "application/json",
//             },
//         });
//         const response = await getAllData.data;
//         const StatusCode = getAllData.status;
//         const result = response.Result;
//         console.log("success in getting all BD Reason", response);
//         return {
//             result,
//             StatusCode
//         }
//     } catch (error) {
//         if (error.response && error.response.status === 400) {
//             const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
//             throw new Error(backendMessage);
//         } else {
//             throw new Error("Something went wrong, please try again later.");
//         }
//     }
// }
// );

export const postTransferReq = createAsyncThunk("postTransferReq", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-transfer-logs`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        };
    } 
    catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message;

            // Check if 'Message' is an object (e.g., validation errors)
            if (typeof backendMessage === 'object' && backendMessage !== null) {
                const validationErrors = Object.entries(backendMessage)
                    .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
                    .join("; ");

                throw new Error(`Validation failed: ${validationErrors}`);
            } else {
                // Handle the case where 'Message' is a string or undefined
                const message = backendMessage || "An error occurred while processing the request";
                throw new Error(message);
            }
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const getAssetTransferLogs = createAsyncThunk("getAssetTransferLogs", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-transfer-logs${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

export const getTransferDOA = createAsyncThunk("getDOA", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/asset_management/asset-transfer-doa`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = getAllData.data;
        const result = response.Result
        const StatusCode = getAllData.status;

        console.log("success in asset data", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }

}
);

export const postTransferApproval = createAsyncThunk("postTransferApproval", async (data) => {
    try {
        const getAllData = await httpClient.post(`/internal-db/internal/db/asset_management/asset-transfer-approvals`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);



const VendorDataSlice = createSlice({
    name: "vendorData",
    initialState: {
        loading: false,
        error: null,
        response: null,
        assetResponse: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getVendorData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getVendorData.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload.result;
            })
            .addCase(getVendorData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(getAssetDataByVendorCode.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getAssetDataByVendorCode.fulfilled, (state, action) => {
                state.loading = false;
                state.assetResponse = action.payload.result;
            })
            .addCase(getAssetDataByVendorCode.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(getAssetwithVendorCode.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getAssetwithVendorCode.fulfilled, (state, action) => {
                state.loading = false;
                state.assetResponse = action.payload.result;
            })
            .addCase(getAssetwithVendorCode.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
})

// export const { logout } = VendorDataSlice.actions;
export default VendorDataSlice.reducer;